// extracted by mini-css-extract-plugin
module.exports = {"CalenderIcon":"DateRange_CalenderIcon__2NrcE"};